import { systemLabelConstants } from "../../../../constants/system/systemLabels/systemLabels.constants";

export function systemLabels(state = {}, action) {
  switch (action.type) {
    case systemLabelConstants.CREATE_SYSTEM_LABEL_REQUEST:
    case systemLabelConstants.GET_SYSTEM_LABEL_GROUP_REQUEST:
      return { ...state, loading: true };
    case systemLabelConstants.CREATE_SYSTEM_LABEL_SUCCESS:
    case systemLabelConstants.GET_SYSTEM_LABEL_GROUP_SUCCESS:
      let newGroups = state.groups ?  { ...state.groups } : {};
      newGroups[action.groupName] = action.group;
      return {
        ...state,
        loading: false,
        groups: newGroups
      };
    case systemLabelConstants.CREATE_SYSTEM_LABEL_FAILURE:
    case systemLabelConstants.GET_SYSTEM_LABEL_GROUP_FAILURE:
      return { ...state, error: action.error };

    case systemLabelConstants.GET_ALL_SYSTEM_LABEL_GROUP_REQUEST:
      return { ...state, loading: true };
    case systemLabelConstants.GET_ALL_SYSTEM_LABEL_GROUP_SUCCESS:
      let groups = {};
      for (const key in action.groups) {
        if (action.groups.hasOwnProperty(key) && key[0]) {
          var newKey = key[0].toUpperCase() + key.substr(1, key.length - 1);
          groups[newKey] = action.groups[key];
        }
      }
      return { ...state, loading: false, groups: groups };
    case systemLabelConstants.GET_ALL_SYSTEM_LABEL_GROUP_FAILURE:
      return { ...state, loading: false, error: action.error };

    case systemLabelConstants.UPDATE_RANGE_SYSTEM_LABEL_REQUEST:
      return { ...state, loading: true };
    case systemLabelConstants.UPDATE_RANGE_SYSTEM_LABEL_SUCCESS:
      return { ...state, loading: false, saved: true };
    case systemLabelConstants.UPDATE_RANGE_SYSTEM_LABEL_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}